import React, {Component} from 'react';
import {translate} from 'react-i18next';
import SearchBar from '../generics/SearchBar';
import {Table} from 'react-bootstrap';
import Moment from 'react-moment';
import WaitingModal from '../generics/WaitingModal';
import SvgIcon from 'react-icons-kit';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import {priceTag} from 'react-icons-kit/icomoon/priceTag';
import ModalPrintLabel from '../generics/ModalPrintLabel';
import swal from 'sweetalert';
import Help from '../generics/help';
import RaisedButton from 'material-ui/RaisedButton';

var Config = require('../../config');

class LabelsList extends Component{
	constructor(props){
		super(props);
		
		var aux_date = new Date();
		
		this.getList = this.getList.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.filterType = this.filterType.bind(this);
		this.onCheck = this.onCheck.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.directPrint = this.directPrint.bind(this);

		this.state = {
			date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			filterText:"",
			reprint_list:[],
			reprint_labels:[],
			preview_print:{},
			columns:[],
			site:"all",
			sites:[],
			hide_labels:false,
			type:"registro"
		}
	}

	componentDidMount(){
		if(this.props.location.pathname.indexOf('multiple_reprint') !== -1){
			this.setState({hide_labels:true});
		}

		fetch(Config.default.apiGateway.URL+'health_facilities',{ 
          method: 'get',
          headers: new Headers({
             'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
             'Accept': 'application/json',
              'Content-Type': 'application/json',
          })
	    })
	    .then(res => {
	        if(res.ok){
	            return res.json();
	          }else{
	            res.text().then(function(error) {
	              swal('¡Error', error, 'error');
	            });
	        }
	    })
	    .then(response => {
	          if(response !== undefined){
	            this.setState({ sites: response });
	          }
	    })



		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}

		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=REPRINT_LABELS',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => {
      		if(response.ok){
      			return response.json();
      		}else{
      			response.text().then((msg)=>{
      				swal('Error', msg, 'error');
      			});
      		}   		
      	}).then(response => {
        	if(response !== undefined){

          		this.setState({ columns: response });
        	}
      	});

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})

		this.getList();
	}

	componentDidUpdate(){
		if(this.props.location.pathname.indexOf('multiple_reprint') !== -1){
			if(!this.state.hide_labels){
				this.setState({hide_labels:true});

				this.getList();
			}

		}else{
			if(this.state.hide_labels){
				this.setState({hide_labels:false});

				this.getList();
			}
		}
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	getList(){
		if(this.state.site !== ""){
			this.waiting_modal.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'offers/reprint_labels?health_facilities_id='+
				this.state.site+'&date='+this.state.date,{
				method : 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			})
			.then(res => res.json())
			.then(response => {
				this.waiting_modal.handleClose();

				if(this.state.hide_labels){
					response.map((res)=>{
						res.check = false;
					});
				}
					

				this.setState({
					reprint_labels:response
				})
			})
		}else{
			swal('Error', 'Debe seleccionar un centro de origen', 'error');
		}
			
	}

	handleUserInput(filterText) {
    	this.setState({filterText: filterText});
  	};

	dateHandleChange(e){
		this.setState({
			date: e.target.value
		});

		setTimeout(function(){
			this.getList();
		}.bind(this), 500)
	}

	openModalLabel(type, id, ext){
		this.modal_print_label.handleShow(type,id, ext,undefined,this.state.preview_print);
	}

	directPrint(response, label_type){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = ()=> {
		  var base64data = reader.result;  
		  var aux = base64data.split(',');
		  this.props.socket.send('{"Operacion":"print", "Type":"'+label_type+'", "File": "'+aux[1]+'"}');
		}
	  }

	filter(row){ 
	    var res = true;	    

	    var text = row.health_facilities+' '+
	    		row.donation_number+' '+
	    		row.offer.donor_id+' '+
	    		row.donation_name+' '+
	    		row.extraction_name+' '+
	    		row.donor_name;

	    if(row !== null){
	    	if(text.indexOf(this.state.filterText.toUpperCase()) !== -1){
	    		res = true
	    	}else{
	    		res = false;
	    	}
	      	
	    }

	    return res
	}

	filterType(row){
		var res = true;
		var text = '';

		if(this.state.type === 'registro'){
			res = true;
		}else if(this.state.type === 'st'){
			text = row.extraction_name;

			if(text.toUpperCase().indexOf(this.state.type.toUpperCase()) !== -1){
				res = true;
			}else{
				res = false;
			}

		}else if(this.state.type === 'af'){
			text = row.extraction_name;

			if(text.toUpperCase().indexOf(this.state.type.toUpperCase()) !== -1){
				res = true;
			}else{
				res = false;
			}
		}

		return res;
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});

		if(e.target.name === 'type'){
			var labels = this.state.reprint_labels;

			labels.map((l, j)=>{
				l.check = false;
				
			});

			this.setState({reprint_labels:labels});
		}
	}

	onCheck(i, e){
		var labels = this.state.reprint_labels;

		if(i === -1){
			labels.map((l, j)=>{
				l.check = e.target.checked;
			});
		}else{
			labels.map((l, j)=>{
				if(i === j){
					l.check = e.target.checked;
				}					
			});
		}

		this.setState({reprint_labels:labels});

	}

	onSave(){
		var ids = [];
		this.state.reprint_labels.map((list)=>{
			if(list.check){
				ids.push(list.offer.id);
			}
		});

		if(ids.length > 0){
			if(this.state.type === 'registro'){
				this.modal_print_label.handleShow('label_register', ids, null, undefined, this.state.preview_print, 'multiple');

			}else{

				this.modal_print_label.handleShow('label_extraction', ids, this.state.type.toUpperCase(), undefined, this.state.preview_print, 'multiple');
			}
		}else{
			swal('Error', 'Debe seleccionar al menos un registro', 'error');
		}
			
	}

	onCancel(){
		this.props.history.push('/');
	}

	render(){
		const {t} = this.props;
		var submenu = this.props.match.url.replace('/', '');
		var session = sessionStorage.getItem('health_facilities_name');
		return (
			<div className="col-xs-12">
				
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.donors.MAIN')} -> 
						{t('sidebar.nav.donors.'+submenu)}
					</h5>
				</div>

	            <Help 
					{...this.props}
	                menu={"help_donors"} 
	                submenu={"help_reprint_labels"}  />
		                
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-md-2">
		                <select className="form-control" name="site" id="site" 
		                	value={this.state.site || ""}
		                  	onChange={this.handleChange}>
		                  	<option value="">Seleccionar...</option>
		                  	<option value="all">Todos</option>
		                  	{this.state.sites.map((s, i)=>(
		                    	<option key={i} value={s.id}>{s.name}</option>
		                  	))}
		                </select>
		            </div>
					<div className="col-xs-12 col-md-3">
						<div className="col-xs-12 col-sm-5">
							<span className="span-min">{t('content.offers.form.show_from')+':'}</span>
						</div>
						<div className="col-xs-12 col-sm-7">
							<input className="form-control" type="date" name="date" id="date"
								value={this.state.date}
								onChange={this.handleChange}/>
						</div>
					</div>

					

					<div className="col-xs-12 col-md-1">
		                <button style={{float:"right", fontSize:"15px", paddingTop:'1px', paddingBottom:'1px'}} className="btn btn-info btn-search" type="button"
		                  	onClick={this.getList}>
		                  	Buscar
		                </button>
		            </div>

				</div>

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-md-2" >
						<SearchBar filterText={this.state.filterText} 
							onUserInput={this.handleUserInput.bind(this)}/>
					</div>

					{this.state.hide_labels ?
						<div className="col-xs-12 col-md-3">
							<div className="col-xs-12 col-sm-5">
								<span className="span-min">Tipo</span>
							</div>
							<div className="col-xs-12 col-sm-7">
								<select className="form-control" name="type" id="type" 
				                	value={this.state.type || ""}
				                  	onChange={this.handleChange}>
				                  	<option value="registro">Registro</option>
				                  	<option value="st">Extracción Sangre Total</option>
				                  	<option value="af">Extracción Aféresis</option>
				                </select>
							</div>
						</div>
					:null}
				</div>

				<div className="col-xs-12 form-group">
					<Table responsive hover>
						<thead>
							<tr>
								<th hidden={!this.state.hide_labels}>
									<input type="checkbox" id="check_all" onChange={(e)=>this.onCheck(-1, e)} />
								</th>
								<th hidden={this.showColumn('ORIGIN')}>Centro</th>
								<th hidden={this.showColumn('DONATION_NUMBER')}>Número Donación</th>
								<th hidden={this.showColumn('OFFER_ID')}>No. Ofrecimiento</th>
								<th hidden={this.showColumn('DONOR_ID')}>Id Donador</th>
								<th hidden={this.showColumn('DONATION_TYPE')}>Tipo Donación</th>
								<th hidden={this.showColumn('EXTRACTION_TYPE')}>Tipo Extracción</th>
								<th hidden={this.showColumn('DONOR_NAME')}>Nombre Donador</th>
								<th hidden={this.showColumn('GROUP_RH')}>Grupo y RH</th>
								<th hidden={this.showColumn('REGISTER_DATE')}>Fecha de Registro</th>
								<th hidden={this.showColumn('EXTRACTION_DATE')}>Fecha de Extracción</th>
								<th hidden={this.showColumn('REGISTER') || this.state.hide_labels}>Registro</th>
								<th hidden={this.showColumn('EXTRACTION') || this.state.hide_labels}>Extracción</th>
							</tr>
						</thead>
						<tbody>
							{this.state.reprint_labels !== undefined ? 
								this.state.reprint_labels.map((label, i)=>(
									this.filter(label) === true && this.filterType(label) ?
										<tr key={i}>
											<td hidden={!this.state.hide_labels}>
												<input type="checkbox" checked={label.check} 
													disabled={this.state.type !== 'registro' ?
														label.donation_id === 0 ? true : false
													:false}
													onChange={(e)=>this.onCheck(i, e)} /> 
											</td>
											<td hidden={this.showColumn('ORIGIN')}>{label.health_facilities}</td>
											<td hidden={this.showColumn('DONATION_NUMBER')}>{label.donation_number}</td>
											<td hidden={this.showColumn('OFFER_ID')}>{label.offer.id}</td>
											<td hidden={this.showColumn('DONOR_ID')}>{label.offer.donor_id}</td>
											<td hidden={this.showColumn('DONATION_TYPE')}>{label.donation_name}</td>
											<td hidden={this.showColumn('EXTRACTION_TYPE')}>{label.extraction_name}</td>
											<td hidden={this.showColumn('DONOR_NAME')}>{label.donor_name}</td>
											<td hidden={this.showColumn('GROUP_RH')}>{label.lookup_group} {label.lookup_rh === 'POSITIVO' ? '+' : label.lookup_rh === 'NEGATIVO' ? '-' : '' }</td>
											<td hidden={this.showColumn('REGISTER_DATE')}>
												{label.offer.timestamp_date !== null ?
													<div><Moment format="DD/MM/YYYY">
													  {label.offer.timestamp_date}
													</Moment>{' '}</div>
													: null
												}
												{label.offer.timestamp_hour !== null ?
													<Moment parse="HH:mm" format="h:mm a">{label.offer.timestamp_hour}</Moment>
													: null
												}
											</td>
											<td hidden={this.showColumn('EXTRACTION_DATE')}>
												{label.extraction_date !== null ?
													<div><Moment format="DD/MM/YYYY">
													  {label.extraction_date}
													</Moment>{' '}</div>
													: null
												}
												{label.extraction_hour !== null ?
													<Moment parse="HH:mm" format="h:mm a">{label.extraction_hour}</Moment>
													: null
												}
											</td>
											<td hidden={this.showColumn('REGISTER') || this.state.hide_labels}>
												<FloatingActionButton backgroundColor={'#ededed'} iconStyle={{height: 33, width: 33}} 
													title="Registro" mini={true} style={{marginLeft:"5px"}} 
													onClick={this.openModalLabel.bind(this,'label_register', label.offer.id, null)}>
							                      	<SvgIcon icon={priceTag} className="icon-align"/>
							                    </FloatingActionButton>
							                </td>
											<td hidden={this.showColumn('EXTRACTION') || this.state.hide_labels}>
							                    <FloatingActionButton backgroundColor={'#ededed'} iconStyle={{height: 33, width: 33}} 
							                    	title="Extracción" disabled={label.donation_id === 0 ? true : false} mini={true} 
							                    	style={{marginLeft:"5px"}}
							                    	onClick={this.openModalLabel.bind(this,"label_extraction", label.donation_id, label.extraction_name)}>
							                      	<SvgIcon icon={priceTag} className="icon-align"/>
							                    </FloatingActionButton>
											</td>
										</tr>
									: null
								))
							: null
							}
						</tbody>
					</Table>
				</div>

				{this.state.hide_labels ? 
					<div className="col-xs-12" style={{textAlign:'center'}}>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.print')} primary={true} 
		        			onClick={this.onSave}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} 
		        			style={{marginLeft:'8px'}} onClick={this.onCancel}/>
			        	
			        </div>
				:null}

				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				<ModalPrintLabel {...this.props} onRef={ref => (this.modal_print_label = ref)} directPrint={this.directPrint}/>
			</div>
		)
	}
}

export default translate('translations')(LabelsList);
